import { render, staticRenderFns } from "./LatestTerms.vue?vue&type=template&id=0c2ec2da"
import script from "./LatestTerms.vue?vue&type=script&lang=js"
export * from "./LatestTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports